import { isNil } from 'lodash';

import { GRID_LENGTH, SPACE_BETWEEN, UnderlineType } from './constants';
import { convertDateToUTC } from '../../../service/DateTimeUtils';
import { DeclarationType } from '../../../service/constants';

export const calculateWidth = (length) => {
    return `${(length * (100 - (GRID_LENGTH - 1) * SPACE_BETWEEN)) / GRID_LENGTH + (length - 1) * SPACE_BETWEEN}%`;
};

export const getTime = (value) => {
    return value && convertDateToUTC(new Date(value));
};

export const getUnderlineType = (value = '', limit, length, required) => {
    let underlineType = UnderlineType.DEFAULT;
    if (!limit && !length) {
        return !value && required ? UnderlineType.BAD_WORK : UnderlineType.WELL_DONE;
    }
    if (!value && required) {
        return UnderlineType.BAD_WORK;
    }
    const diffLimit = limit ? value - limit : 0;
    const diffLength = length && !isNil(value) ? value.toString().length - length : 0;

    if (diffLimit <= 0 && diffLength <= 0) {
        underlineType = UnderlineType.WELL_DONE;
    } else if (diffLimit > 0 || diffLength > 0) {
        underlineType = UnderlineType.BAD_WORK;
    }

    return underlineType;
};

const getFieldProps = (
    type,
    {
        defaultValue,
        focusID,
        handleChangeTime,
        id,
        length,
        maxRows,
        minRows,
        multiline,
        onBlur,
        onChange,
        onClick,
        required,
        title,
        underlineType,
        validator,
        shortcuts,
    }
) => {
    switch (type.toLowerCase()) {
        case DeclarationType.DATE:
            return {
                defaultValue,
                id,
                length,
                required,
                title,
                onTimeChange: handleChangeTime,
            };
        case DeclarationType.TEXT:
        case DeclarationType.NUMBER:
            return {
                defaultValue,
                focusID,
                id,
                length,
                maxRows,
                minRows,
                multiline,
                onBlur,
                onChange,
                onClick,
                required,
                title,
                type,
                underlineType,
                validator,
                shortcuts,
            };
        default:
            return {
                length,
                title,
            };
    }
};

export { getFieldProps };
